import { gql } from "@apollo/client";

export const LocationInfoFragment = gql`
  fragment LocationInfo on Location {
    latitude
    longitude
  }
`;

export const AddressInfoFragment = gql`
  fragment AddressInfo on Address {
    country
    city
    region
    address
    additional_address
    location {
      ...LocationInfo
    }
    place_id
  }
  ${LocationInfoFragment}
`;

